import camelCase from 'lodash/camelCase';
import mapKeys from 'lodash/mapKeys';
import mapValues from 'lodash/mapValues';

type KV = { [key: string]: string };

const formatAuthBackendValidationErrors = (
  backendErrors: { [key: string]: string[] },
  valueFunc: (values: KV) => KV = (v) => v,
) => {
  const backendErrorStrings = mapValues(
    backendErrors,
    (errorArray: string[]) => `Server validation error: ${errorArray.join(' ')}`,
  );

  return valueFunc(mapKeys(backendErrorStrings, (_: string[], key: string) => camelCase(key)));
};

export default formatAuthBackendValidationErrors;
